import { useEffect, useState } from 'react'
import ClearIcon from '@mui/icons-material/Clear'
import ComentarioIcon from '@mui/icons-material/SpeakerNotesOutlined'
import { Text } from '../../../../../ui'

const ModalComentarios = ({
  open,
  onClose,
  onSave,
  initialValue = '',
  rowId = null
}) => {
  const [comment, setComment] = useState(initialValue)
  const [isSaving, setIsSaving] = useState(false)

  useEffect(() => {
    if (open) {
      setComment(initialValue || '')
      setIsSaving(false)
    }
  }, [initialValue, open])

  const handleSave = async () => {
    try {
      setIsSaving(true)
      await onSave(comment)
    } finally {
      setIsSaving(false)
    }
  }

  if (!open) return null

  return (
    <div
      className='fixed inset-0 z-[1300] flex items-center justify-center bg-black/40 px-4 backdrop-blur-sm'
      onMouseDown={(event) => {
        if (!isSaving && event.target === event.currentTarget) onClose()
      }}
    >
      <div
        className='w-full max-w-[520px] overflow-hidden rounded-[24px] bg-[#f2f2f2] shadow-2xl'
        onMouseDown={(event) => event.stopPropagation()}
      >
        <div className='bg-primary px-4 py-1 flex items-center justify-between'>
          <div className='flex items-center gap-2 text-white'>
            <Text className='text-sm font-semibold text-white'></Text>
          </div>

          <button
            type='button'
            onClick={onClose}
            disabled={isSaving}
            className='rounded-full p-1 text-white transition-colors hover:bg-white/20'
            aria-label='Cerrar comentarios'
          >
            <ClearIcon fontSize='small' />
          </button>
        </div>

        <div className='p-4'>
          <div className='rounded-[22px] border border-slate-200 bg-white p-4 shadow-sm'>
            <div className='flex items-start gap-3'>
              <div className='flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-primary/10 text-primary'>
                <ComentarioIcon fontSize='small' />
              </div>

              <div className='min-w-0'>
                <Text className='text-sm font-semibold text-slate-800'>
                  Comentario del movimiento
                </Text>
                {/*<Text className='mt-1 text-xs text-gray-500'>
                  {rowId ? `Movimiento #${rowId}` : 'Agrega una nota para este movimiento'}
                </Text>*/}
              </div>
            </div>

            <div className='mt-4'>
              <textarea
                value={comment}
                onChange={(event) => setComment(event.target.value)}
                placeholder='Escribe un comentario para este movimiento'
                rows={5}
                maxLength={100}
                className='min-h-[132px] w-full resize-none rounded-[20px] border border-gray-200 bg-slate-50 px-4 py-3 text-sm text-slate-700 outline-none transition-colors placeholder:text-gray-400 focus:border-accent2 focus:bg-white'
              />

              <div className='mt-2 flex items-center justify-between gap-3'>
                <Text className='text-[11px] text-gray-400'>
                </Text>
                <Text className='text-[11px] text-gray-400'>{comment.length}/100</Text>
              </div>
            </div>
          </div>
        </div>

        <div className='px-4 py-3 flex justify-end gap-2'>
          <button
            type='button'
            onClick={onClose}
            disabled={isSaving}
            className='rounded-full bg-primary px-5 py-2 text-xs font-semibold text-white transition-opacity hover:opacity-90'
          >
            Cancelar
          </button>
          <button
            type='button'
            onClick={handleSave}
            disabled={isSaving}
            className='rounded-full bg-accent2 px-5 py-2 text-xs font-semibold text-white transition-opacity hover:opacity-90 disabled:cursor-not-allowed disabled:opacity-60'
          >
            {isSaving ? 'Guardando...' : 'Guardar'}
          </button>
        </div>
      </div>
    </div>
  )
}

export default ModalComentarios
